import { render } from "./ReclaimButton.vue?vue&type=template&id=4d3bbecc&ts=true"
import script from "./ReclaimButton.vue?vue&type=script&lang=ts"
export * from "./ReclaimButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__